



export function processGalleries(base = document) {
    const disp = (window.screen.width)<=480?'mobile':(window.screen.width)<=780?'tablet':'desktop';
    base.querySelectorAll('.wp-block-smarttouch-gallery > div').forEach(el=>{
        const config = JSON.parse(LZUTF8.decompress(el.dataset.config,{inputEncoding:'Base64'}));
        let ratio = config[disp].ratio||config.desktop.ratio;
        if(ratio=='custom') ratio = config[disp].customRatio||config.desktop.customRatio;
        if(+(ratio)==0) ratio = '56.25';
        el.style.setProperty('--ratio',ratio+'%');
        el.style.setProperty('--count',el.querySelectorAll('.media').length);
        if(el.classList.contains('is-type-slideshow')) {
            let on = {
				lazyImageLoad: (swiper,slide,image) => {
					if(!image.dataset.resp) return;
					const resp = JSON.parse(LZUTF8.decompress(image.dataset.resp,{inputEncoding:'Base64'}));
                    let url = resp[disp].url||resp.desktop.url;
                    if(window.themefolder&&(slide.offsetWidth>5)&&(slide.offsetHeight>5)) {
                        url = window.themefolder+'image.php?w='+slide.offsetWidth+'&h='+slide.offsetHeight+'&src='+encodeURIComponent(url);
                    }
                    let scaleby = slide.offsetWidth / resp[disp].width * resp[disp].height;
                    if(scaleby>slide.offsetHeight) { scaleby = 'width'; } else { scaleby = 'height'; }
                    slide.classList.add('scale-'+scaleby);
                    slide.style.setProperty('--focalx',resp[disp].focalx*100+'%');
                    slide.style.setProperty('--focaly',resp[disp].focaly*100+'%');
                    slide.style.setProperty('--scale',resp[disp].scale);
					image.style.backgroundImage = 'url('+url+')';
				}
			}
            if(config.verticalParallax) {
                const stc = el.querySelectorAll('.media-wrapper .photo');
                ScrollTrigger.create({
                    id: 'verticalParallax',
                    trigger: el,
                    start: 'top top',
                    end: 'bottom top',
                    scrub: true,
                    onUpdate: (e) => {
                        const top = Math.round(e.progress*el.offsetHeight/2) + 'px';
                        stc.forEach(el=>el.style.transform = "translateY("+top+")");
                    }
                })
            }
            if(config.horizontalParallax&&(config.swiper.effect!='coverflow')) {
                on = lodash.merge(on,{
                    progress: function(swiper, progress) {
                        for (let i = 0; i < swiper.slides.length; i++) {
                            let slideProgress = swiper.slides[i].progress;
                            let innerOffset = swiper.width * 0.5;
                            let innerTranslate = slideProgress * innerOffset;
                            swiper.slides[i].querySelector(".photo").style.transform = "translate3d(" + innerTranslate + "px,0,0)";
                        };
                    },
                    touchStart: function(swiper, event) {
                        for (let i = 0; i < swiper.slides.length; i++) {
                            swiper.slides[i].style.transition = "";
                        }
                    },
                    setTransition: function(swiper, speed) {
                        for (let i = 0; i < swiper.slides.length; i++) {
                            swiper.slides[i].style.transition = speed + "ms";
                            swiper.slides[i].querySelector(".photo").style.transition = speed + "ms";
                        }
                    }
                });
            }
            var swiper = new Swiper(el,lodash.merge(config.swiper,{
				preloadImages: false,
				lazy: {
					loadPrevNext: true
				},
				watchSlidesProgress: true,
                centerMode: true,
                loop: true,
				on: on
			}));
        } else {
            const gallery = [];
            config.media.forEach(i=>gallery.push({...config.meta[i].desktop}));
            el.firstChild.classList.add('cols'+config[disp].columns);
			el.querySelectorAll('[data-resp]').forEach((i,index)=>{
				const resp = JSON.parse(LZUTF8.decompress(i.dataset.resp,{inputEncoding:'Base64'}));
                const url = resp[disp].url||resp.desktop.url;
                const media = i.parentElement;
                let scaleby = media.offsetWidth / resp[disp].width * resp[disp].height;
                if(scaleby>media.offsetHeight) { scaleby = 'width'; } else { scaleby = 'height'; }
                media.classList.add('scale-'+scaleby);
				media.style.setProperty('--focalx',resp[disp].focalx*100+'%');
				media.style.setProperty('--focaly',resp[disp].focaly*100+'%');
				media.style.setProperty('--scale',resp[disp].scale);
                if(el.classList.contains('click-to-expand')) {
                    media.onclick = function(){
                        popupGallery(index, gallery);
                    }
                }
                ScrollTrigger.create({
                    trigger: i,
                    start: 'top bottom-=100px',
                    showTriggers: true,
                    once: true,
                    onEnter: () => {
                        const img = document.createElement('img');
                        img.onload = () => {
                            //i.src = img.src;
                            i.style.backgroundImage = 'url('+img.src+')';
                            media.classList.add('loaded');
                        }
                        if(window.themefolder&&(media.offsetWidth>5)&&(media.offsetHeight>5)) {
                            img.src = window.themefolder+'image.php?w='+media.offsetWidth+'&h='+media.offsetHeight+'&src='+encodeURIComponent(url);
                        } else {
                            img.src = url;
                        }
                    }
                })
			});
        }
    });
}